import { React } from "react";

export default function NullPage() {
  return <div className="null"></div>;
}
